import axios from "axios";
import { DefaultApi } from "../../../generated";

const axiosBaseUrl = import.meta.env.VITE_BACKEND_BASE_URL || "/";

export const axiosBackendClient = axios.create({
  baseURL: axiosBaseUrl,
});

export const api = new DefaultApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  axiosBackendClient,
);

export default api;

export function injectBearerToken(getToken: () => Promise<string>): () => void {
  const id = axiosBackendClient.interceptors.request.use(async (config) => {
    const token = await getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return () => axiosBackendClient.interceptors.request.eject(id);
}
